module.exports = __webpack_public_path__ + "img/keder_oekograu_restpaste.0d1bbe4c.jpg";